// Which logbook tab the in-match panel opens on. Persisted via the shared
// preferences store so "show me both" is a setting the player picks once,
// not a click at the start of every match.

import { getPref, setPref } from '../persistentPrefs';

const STORAGE_KEY = 'fab-arena-logbook-tab';

export const LOGBOOK_TABS = ['log', 'chat', 'both'];

export function getLogbookTab() {
  const stored = getPref(STORAGE_KEY, null);
  return LOGBOOK_TABS.includes(stored) ? stored : 'log';
}

export function saveLogbookTab(tab) {
  if (LOGBOOK_TABS.includes(tab)) setPref(STORAGE_KEY, tab);
}
